/** Keep a fixed popover (top-left anchored) inside the viewport. */
export function fitFixedPopoverToViewport({
    triggerRect,
    popoverWidth,
    popoverHeight,
    estimatedWidth = 720,
    estimatedHeight = 420,
    gap = 8,
    edge = 8,
}) {
    const width = popoverWidth || estimatedWidth
    const height = popoverHeight || estimatedHeight
    const vw = window.innerWidth
    const vh = window.innerHeight

    // Prefer align to trigger left; if that overflows right, shift left; then clamp.
    let left = triggerRect.left
    if (left + width > vw - edge) {
        left = vw - edge - width
    }
    if (left < edge) {
        left = edge
    }

    // Prefer below trigger; flip above when needed; then clamp.
    let top = triggerRect.bottom + gap
    if (top + height > vh - edge) {
        const above = triggerRect.top - height - gap
        if (above >= edge) {
            top = above
        } else {
            top = Math.max(edge, Math.min(top, vh - edge - height))
        }
    }

    return { top, left }
}
